type Listener = () => void;

class ErrorStore {

  private errors: string[] = [];
  private listeners = new Set<Listener>();

  get hasErrors() {
    return this.errors.length > 0;
  }

  public addError(msg: string) {
    this.errors.push(msg);
    this.listeners.forEach(listener => listener());
  }

  /** Notifies the listener about new errors. Returns a function that removes the listener again. */
  public subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const errorStore: ErrorStore = new ErrorStore();
